import React from 'react';

// 「?」帮助提示: 页面常驻说明文字收进气泡, 悬停显示 — 保持界面干净, 需要时才看.
function HelpTip({ text, className }: { text: React.ReactNode; className?: string }) {
    return (
        <span className={`relative inline-flex group align-middle ${className || ''}`}>
            <span className="w-4 h-4 rounded-full bg-slate-200 text-slate-500 text-[10px] leading-4 text-center cursor-help select-none group-hover:bg-brand-100 group-hover:text-brand-600">
                ?
            </span>
            {/* 左对齐锚定 (不用居中: 图标常靠页面左侧, 居中会被视口裁掉) */}
            <span className="pointer-events-none absolute left-0 top-5 z-50 hidden group-hover:block w-72 max-w-[80vw] bg-slate-800 text-white text-xs rounded-lg px-3 py-2 shadow-lg whitespace-normal text-left font-normal leading-relaxed">
                {text}
            </span>
        </span>
    );
}

export default HelpTip;
